import { ScheduleProps } from '../../components/meals/AddMeals';
export const GET_COOK_MEALS = 'GET_COOK_MEALS';
export const SET_MEAL = 'SET_MEAL';
export const ADD_REPORT = 'ADD_REPORT';
export const SET_REVIEWS = 'SET_REVIEWS';
export const GET_REVIEWS = 'GET_REVIEWS';

export interface FirestoreSnapshot {
  id: string;
  data: Function;
}

export interface DateObjects {
  seconds?: any;
  nanoseconds?: string;
}

export interface CookMeals {
  id: string;
  title: string;
  image?: string;
  description?: string;
  price: string;
  mealprice: string;
  portions: number;
  consumption: string;
  cook: string;
  schedule: ScheduleProps[];
  visible: boolean;
  timeadded: DateObjects;
  category: any[];
  restrictions: any[];
}

export interface UserReviews {
  mealid: string;
  firstName: string;
  image: string;
  message: string;
  rate: number;
  timeadded: DateObjects;
}

export interface AddReport {
  reportedby: string;
  user: string;
  message: string;
  timeadded: Date;
}

export interface CooksMealProps {
  meals: Array<CookMeals>;
  reviews: Array<UserReviews>;
}

export interface GetMealAction extends CooksMealProps {
  type: typeof GET_COOK_MEALS;
  cookid: string;
}

export interface SetMealActionType extends CooksMealProps {
  type: typeof SET_MEAL;
  meals: Array<CookMeals>;
}

export interface AddReportAction extends CooksMealProps {
  type: typeof ADD_REPORT;
  report: AddReport;
}

export interface GetReviewsAction extends CooksMealProps {
  type: typeof GET_REVIEWS;
  meal: CookMeals;
}

export interface SetReviewsType extends CooksMealProps {
  type: typeof SET_REVIEWS;
  reviews: Array<UserReviews>;
}

export type CooksProfileActionTypes =
  | GetMealAction
  | SetMealActionType
  | GetReviewsAction
  | SetReviewsType;
